import { cn } from "@/utils";
import * as ToastPrimitives from "@radix-ui/react-toast";
import { X } from "lucide-react";
import React from "react";

const ToastClose = React.forwardRef<
  React.ElementRef<typeof ToastPrimitives.Close>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitives.Close>
>(({ className, ...props }, ref) => (
  <ToastPrimitives.Close
    ref={ref}
    className={cn(
      "absolute right-3 top-[10px] rounded-md transition-opacity outline-none cursor-pointer hover:bg-gray-100 p-1",
      className
    )}
    toast-close=""
    {...props}
  >
    <X className="h-4 w-4" />
  </ToastPrimitives.Close>
));
ToastClose.displayName = ToastPrimitives.Close.displayName;

export { ToastClose };
